<template>

    <div class="buttonSound" @click="playClick" :class="{'buttonSound-isWhite': isWhite, 'buttonSound-isNotPlaying': !isPlaying}">
        <svg xmlns="http://www.w3.org/2000/svg" width="42.955" height="42.955" viewBox="0 0 42.955 42.955">
            <g transform="translate(-82.5 -466.5)">
                <g class="buttonSound_circle" transform="translate(82.5 466.5)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="2">
                    <circle cx="21.478" cy="21.478" r="21.478" stroke="none"/>
                    <circle cx="21.478" cy="21.478" r="20.478" fill="none"/>
                </g>
                <path class="speaker" d="M514.729,741.719H518.7l3.807-3.586v12.575l-3.807-3.66h-3.968Z" transform="translate(-420.301 -256.003)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path class="soundPath1" d="M573.844,762.238a1.985,1.985,0,0,1,1.345,1.947,1.7,1.7,0,0,1-1.345,1.6" transform="translate(-468.447 -275.635)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path class="soundPath2" d="M581.15,744.15s3.459,1.544,3.433,5.055a6.2,6.2,0,0,1-3.042,5.143" transform="translate(-474.397 -260.904)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path class="soundPath3" d="M590.4,726.85s5.344,2.8,5.362,8.27A9.979,9.979,0,0,1,590.4,743.8" transform="translate(-482.336 -246.997)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
        </svg>
        <span class="buttonSound_legend" v-if="legend" v-html="legend"></span>
    </div>

</template>

<script>

    import {SoundManager, ESoundType} from '../utils/SoundManager';

    export default {
        name: 'ButtonSound',
        props: ['src', 'legend','loop', 'autoplay', 'isWhite'],
        data: function(){
            return{
                isPlaying: false,
                soundPath: require('../assets/audio/' + this.src),
            };
        },
        methods: {
            play(){
                SoundManager.instance.load( ESoundType.AMBIANCE, this.soundPath );
                SoundManager.instance.playAmbiance(this.soundPath, 1, 1, this.loop);
                this.isPlaying = true;
            },
            playClick(){
                if(this.isPlaying){
                    SoundManager.instance.stopAmbiance();
                    this.isPlaying = false;
                    return;
                }
                this.play();
            }
        },
        mounted: function(){
            if(this.autoplay && SoundManager.instance.canAutoLoadSound()){
                this.play();
            }
        },
    };
</script>

<style scoped lang="scss">

    @keyframes bounce {
        0% {transform: translateX(0);}
        5% {transform: translateX(-5px);}
        10% {transform: translateX(5px);}
        15% {transform: translateX(-5px);}
        20% {transform: translateX(5px);}
        25% {transform: translateX(0);}
    }

    @keyframes fadeSoundPath1 {
        0% {opacity: 0;}
        60% {opacity: 1;}
        100% {opacity: 1;}
    }

    @keyframes fadeSoundPath2 {
        0% {opacity: 0;}
        20% {opacity: 0;}
        80% {opacity: 1;}
        100% {opacity: 1;}
    }

    @keyframes fadeSoundPath3 {
        0% {opacity: 0;}
        40% {opacity: 0;}
        100% {opacity: 1;}
    }


    .buttonSound {
        position: fixed;
        z-index: $ZI-menuBtn;
        cursor: pointer;
        display: flex;
        align-items: center;
        left: $G-default;
        top: 50%;
        transform: translateY(-50%);
        color: #000000;
        padding-right: $G-default / 2;

        .speaker {     
            transition: 0.25s ease-in-out;
        }

        .soundPath1 {
            animation: fadeSoundPath1 2.5s 0s ease-in-out infinite;
        }

        .soundPath2 {
            animation: fadeSoundPath2 2.5s 0s ease-in-out infinite;
        }

        .soundPath3 {
            animation: fadeSoundPath3 2.5s 0s ease-in-out infinite;
        }

        &_legend {
            padding-left: $G-default / 2;
            font-size: 1.5rem;
        }

        &-isWhite{
            color: #fff;
        }

        &-isNotPlaying{
            animation: bounce 2s ease-in-out infinite alternate;

            .soundPath1 {
                animation: none;
                opacity: 0;
            }

            .soundPath2 {
                animation: none;
                opacity: 0;
            }

            .soundPath3 {
                animation: none;
                opacity: 0;
            }

            .speaker {
                transform: translate(-416.000px, -256.003px);
                transition: 0.25s ease-in-out;
            }
        }

        .buttonSound_circle,
        svg path{
            stroke: currentColor;
        }

        &_nolegend {
            .buttonSound_legend {
                display:none;
            }
        }
    }
</style>